import { FieldValues, Path, UseFormRegister } from "react-hook-form";
import clsx from "clsx";

interface IProps<T extends FieldValues>
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string;
  name?: Path<T>;
  className?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  register?: UseFormRegister<T>;
}

export default function Radio<T extends FieldValues>({
  label,
  value,
  onChange,
  name,
  className,
  checked,
  register
}: Readonly<IProps<T>>) {
  return (
    <label className="flex items-start gap-2 cursor-pointer">
      <input
        type="radio"
        value={value}
        onChange={onChange}
        className="peer"
        checked={checked}
        {...(register && name && register(name))}
        hidden
      />
      <div className="flex float-none mt-0.5 size-5 rounded-full border border-text peer-checked:after:content-[''] peer-checked:after:size-1.5 peer-checked:after:rounded-full peer-checked:after:m-auto peer-checked:after:bg-text"></div>
      <span className={clsx("text-text", className)}>{label}</span>
    </label>
  );
}
